import React from 'react';

export default function Logo({ className }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img 
        src="https://media-manager-c.questera.ai/greta-media/0b3af998e770acea81dd65e1f88cbe23e5433846e0d8905ff7ba265c9308956ef02252169608e8dd98a402f9c5748de4/images/aW1hZ2UvanBlZw==/6ab1ac0d067a4c9f4ca62074233cd142.jpeg" 
        alt="Drive Pal Logo" 
        className="w-12 h-12 rounded-full object-cover border-2 border-brand-gold shadow-sm"
      />
      <div className="flex flex-col leading-none">
        <span className="font-display text-2xl tracking-wide text-brand-gold">
          DRIVE <span className="ml-1 px-1.5 rounded bg-white text-brand-navy shadow-sm">PAL</span>
        </span>
        <span className="font-display text-[0.65rem] tracking-[0.2em] uppercase text-white/80">
          Driving School
        </span>
      </div>
    </div>
  );
}